import Api from './api'
import response from '../../../utils/response'

export default {
  thousandthsConversion: {
    methods: {
      // 批量获取规则
      async getSystemRules () {
        const api = Api.getListByRuleKey
        const params = [
          // 金额，单价是否开启千分位
          'amount_unit_price_thousands_config',
          // 数量是否开启千分位
          'number_thousands_config'
        ]
        const url = `/${window.fe.project}${api.url}`
        const {code, content} = await response(
          {
            method: api.type,
            url: url,
            params: params
          }
        )
        if (code === 'success') {
          return content
        }
      },
      // 供应商获取规则
      async getSystemRule () {
        const api = Api.getRuleByKey
        const url = `/supplier${api.url}`
        const amountPromise = response(
          {
            method: api.type,
            url: url,
            params: {
              key: 'amount_unit_price_thousands_config'
            }
          }
        )
        const numberPromise = response(
          {
            method: api.type,
            url: url,
            params: {
              key: 'number_thousands_config'
            }
          }
        )
        const [amountRes, numberRes] = await Promise.all([amountPromise, numberPromise])
        if (amountRes.code === 'success' && numberRes.code === 'success') {
          return {
            'amount_unit_price_thousands_config': amountRes.content,
            'number_thousands_config': numberRes.content
          }
        }
      }
    }
  }
}
